import { render, staticRenderFns } from "./live-list-ticket.vue?vue&type=template&id=9e32d83c&scoped=true&"
import script from "./live-list-ticket.vue?vue&type=script&lang=js&"
export * from "./live-list-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e32d83c",
  null
  
)

export default component.exports